import { expressUrl } from '../Links';
import {
    TRANSITION,
    CLIENT_CONSENT,
    CLIENT_CONSENT_REENROLL,
    CLIENT_EXPIRED,
    CLIENT_REENROLL,
    CO_CLIENT_CONSENT,
    CO_CLIENT_CONSENT_REENROLL,
    CO_CLIENT_REENROLL,
    CO_CLIENT_EXPIRED,
    CONSENT_GIVEN,
    CONSENT_GIVEN_REENROLL,
    APPOINTMENT_INFO,
    APPOINTMENT_INFO_REENROLL,
    PLAN_DELIVERED,
    MONITOR,
    ACCOUNT_SELECTION,
} from './ProfileRoutes';



export const expressPathClient = {
    type: 'EXPRESS_PATH_CLIENT',
    externalUrl: `${expressUrl}`,
    priority: 1,
    conditions: {
        isPrimary: true,
        hasEnteredPin: false,
        isNEWE: true,
        isExpressEng: true,
    }
};

export const expressEngagementClient = {
    type: 'EXPRESS_ENGAGEMENT_CLIENT',
    externalUrl: `${expressUrl}`,
    priority: 1,
    conditions: {
        isPrimary: true,
        isNEWE: false,
        isExpressEng: true
    }
}

export const onboardingClient = {
    type: 'ONBOARDING_CLIENT',
    route: TRANSITION,
    priority: 2,
    description: 'Client is net new; not expired, no consent, no existing HH',
    conditions: {
        isPrimary: true,
        hasValidConsent: false,
        nullGroup: true,
        hasEnteredPin: false
    }
};

export const advisorLedOnboardingClient = {
    type: 'ADVISOR_LED_ONBOARDING_CLIENT',
    route: CLIENT_CONSENT,
    priority: 1,
    description: 'Client is primary, PRCN, not RAS HH, valid PRCN consent',
    conditions: {
        isPrimary: true,
        isPRCN: true,
        isRasHH: false,
        hasPrcnNeedsConsent: true,
    }

};

export const expiredPrcnEngagementClient = {
    type: 'EXPIRED_PRCN_ENGAGEMENT_CLIENT',
    route: CLIENT_REENROLL,
    priority: 1,
    description: 'Client is primary, PRCN, no valid consent',
    conditions: {
        isPrimary: true,
        isPRCN: true,
        isRasHH: false,
        hasValidConsent: false,
        hasExpiredPrcnEngagement: true,
    }
};

export const expiredPrcnEngagementCoClient = {
    type: 'EXPIRED_PRCN_ENGAGEMENT_COCLIENT',
    route: CO_CLIENT_REENROLL,
    priority: 1,
    description: 'Co-client is PRCN, no valid consent, HH has expired engagement',
    conditions: {
        hasExpiredPrcnEngagement: true,
        isPRCN: true,
        hasValidConsent: false,
        educationContinue: false,
        queryParam: false,
        multipleClients: true,
        isPrimary: false
    }
};

export const expiredPrcnEngagementRasClient = {
    type: 'EXPIRED_PRCN_ENGAGEMENT_RAS_CLIENT',
    route: MONITOR,
    priority: 1,
    conditions: {
        hasExpiredPrcnEngagement: true,
        educationContinue: false,
        queryParam: false,
        isPrimary: true,
        isRasHH: true,
        isPRCN: true
    }
};


export const expiredPrcnEngagementRasCoClient = {
    type: 'EXPIRED_PRCN_ENGAGEMENT_RAS_COCLIENT',
    route: MONITOR,
    priority: 1,
    conditions: {
        hasExpiredPrcnEngagement: true,
        educationContinue: false,
        queryParam: false,
        isPrimary: false,
        isRasHH: true,
        isPRCN: true
    }
};

export const advisorLedRasHHClient = {
    type: 'ADVISOR_LED_RAS_HH_CLIENT',
    route: ACCOUNT_SELECTION,
    description: 'Advisor Led client in a RAS Household needing consent',
    priority: 1,
    conditions: {
        hasPrcnNeedsConsent: true,
        isRasHH: true,
        isPrimary: true,
        isPRCN: true
    }
};

export const preProspCompletionCoClient = {
    type: 'PRE_PROSP_COMPLETION_CO_CLIENT',
    route: APPOINTMENT_INFO,
    priority: 1,
    conditions: {
        isProspClient: true,
        isProspCompleted: false,
        isPrimary: false,
        clientExpired: false
    }
};

export const clientReenrollCoClientLedEngagement = {
    type: 'CLIENT_REENROLL_CO_CLIENT_LED_ENGAGEMENT',
    route: CLIENT_CONSENT_REENROLL,
    priority: 2,
    conditions: {
        isPrimary: true,
        clientExpired: true,
        reenroll: true,
        isRasHH: false,
        multipleClients: true,
        coClientExpired: false
    }
}

export const onboardingCoClient = {
    type: 'ONBOARDING_CO_CLIENT',
    route: CO_CLIENT_CONSENT,
    priority: 2,
    description: 'Net new planning partner joining non-ras household',
    conditions: {
        hasEnteredPin: true,
        isPrimary: false,
        hasValidConsent: false,
        nullGroup: true,
        notRasOnboarding: false
    }
};

export const advisorLedOnboardingCoClient = {
    type: 'ADVISOR_LED_ONBOARDING_CO_CLIENT',
    route: CO_CLIENT_CONSENT,
    priority: 1,
    description: 'Client is not primary, PRCN, not RAS HH',
    conditions: {
        isPrimary: false,
        isPRCN: true,
        multipleClients: true,
        isRasHH: false,
        hasPrcnNeedsConsent: true,
    }
};

export const advisorLedRasHHCoClient = {
    type: 'ADVISOR_LED_RAS_HH_CO_CLIENT',
    route: ACCOUNT_SELECTION,
    description: 'Advisor Led planning partner in a RAS Household needing consent',
    priority: 1,
    conditions: {
        hasPrcnNeedsConsent: true,
        isRasHH: true,
        isPrimary: false,
        multipleClients: true,
        isPRCN: true
    }
};

export const rasActiveHHCoClientJoin = {
    type: 'RAS_ACTIVE_HH_CO_CLIENT_JOIN',
    route: ACCOUNT_SELECTION,
    priority: 2,
    description: 'Co client joining existing Ras active HH',
    conditions: {
        isRasActive: true,
        clientExpired: false,
        coClientExpired: true,
    }
}

export const rasHHcoClientLedRoundTripCTSClient = {
    type: 'RAS_HH_COCLIENT_LED_RT_CTS_CLIENT',
    description: 'User has a RAS engagment that was previously led by a CC before CTS',
    route: ACCOUNT_SELECTION,
    priority: 2,
    conditions: {
        isPrimary: true,
        isRasHH: true,
        clientExpired: true,
        hasActiveEngagement: true,
        educationContinue: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
    }
}

export const prosperusClient = {
    type: 'PROSPERUS_CLIENT',
    route: TRANSITION,
    priority: 2,
    description: 'Client has hit initial prosperus consent',
    conditions: {
        isPrimary: true,
        isNEWP: true,
        clientExpired: false,
        hasEnteredPin: false,
        pastEngagements: false,
        isRasHH: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
        isPRCN: false
    }
};

export const kyccClient = {
    type: 'PROSPERUS_KYCC_CLIENT',
    route: TRANSITION,
    priority: 2,
    description: 'Client has completed KYC section in prosperus',
    conditions: {
        isPrimary: true,
        isKYCC: true,
        clientExpired: false,
        hasEnteredPin: false,
        pastEngagements: false,
        isRasHH: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
        isPRCN: false
    }
};

export const glscClient = {
    type: 'PROSPERUS_GLSC_CLIENT',
    route: TRANSITION,
    priority: 2,
    description: 'Client has completed Goals section in prosperus',
    conditions: {
        isPrimary: true,
        isGLSC: true,
        clientExpired: false,
        hasEnteredPin: false,
        pastEngagements: false,
        isRasHH: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
        isPRCN: false
    }
};

export const rtqcClient = {
    type: 'PROSPERUS_RTQC_CLIENT',
    route: TRANSITION,
    priority: 2,
    description: 'Client has completed RTQ section in prosperus',
    conditions: {
        isPrimary: true,
        isRTQC: true,
        clientExpired: false,
        hasEnteredPin: false,
        pastEngagements: false,
        isRasHH: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
        isPRCN: false
    }
};

export const intcClient = {
    type: 'PROSPERUS_INTC_CLIENT',
    route: TRANSITION,
    priority: 2,
    description: 'Client has completed Internal Accounts section in prosperus',
    conditions: {
        isPrimary: true,
        isINTC: true,
        clientExpired: false,
        hasEnteredPin: false,
        pastEngagements: false,
        isRasHH: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
        isPRCN: false
    }
};

export const extcClient = {
    type: 'PROSPERUS_EXTC_CLIENT',
    route: TRANSITION,
    priority: 2,
    description: 'Client has completed External Accounts section in prosperus',
    conditions: {
        isPrimary: true,
        isEXTC: true,
        clientExpired: false,
        hasEnteredPin: false,
        pastEngagements: false,
        isRasHH: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
        isPRCN: false
    }
};

export const mancClient = {
    type: 'PROSPERUS_MANC_CLIENT',
    route: TRANSITION,
    priority: 2,
    description: 'Client has completed Manual Accounts section in prosperus',
    conditions: {
        isPrimary: true,
        isMANC: true,
        clientExpired: false,
        hasEnteredPin: false,
        pastEngagements: false,
        isRasHH: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
        isPRCN: false
    }
};

export const fpacClient = {
    type: 'PROSPERUS_FPAC_CLIENT',
    route: TRANSITION,
    secondaryRoute: APPOINTMENT_INFO,
    priority: 2,
    description: 'Client has submitted all accounts and acknowledged the review section in prosperus',
    conditions: {
        isPrimary: true,
        isFPAC: true,
        clientExpired: false,
        hasEnteredPin: false,
        pastEngagements: false,
        isRasHH: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
        isPRCN: false
    }
};

export const reenrollClient = {
    type: 'REENROLL_CLIENT',
    route: TRANSITION,
    description: 'Client is expired, no plan, no consent, no active engagement, not PRCN',
    priority: 2,
    conditions: {
        clientExpired: true,
        hasEnteredPin: false,
        hasDocuments: false,
        isReenroll: true,
        isPrimary: true,
        isRasHH: false,
        hasValidConsent: false,
        hasActiveEngagement: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
        isPRCN: false
    }

};

export const clientExpiredReenroll = {
    type: 'CLIENT_EXPIRED_REENROLL',
    route: CLIENT_REENROLL,
    priority: 2,
    conditions: {
        clientExpired: true,
        hasEnteredPin: false,
        isReenroll: false,
        nullGroup: false,
        queryParam: false,
        isPrimary: true,
        isRasHH: false,
        hasValidConsent: false,
        hasActiveEngagement: false,
        hasDocuments: true,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
    }
};

export const clientExpiredNoPlan = {
    type: 'CLIENT_EXPIRED_NO_PLAN',
    route: CLIENT_EXPIRED,
    description: 'Client is expired, no plan, no consent, no active engagement',
    priority: 2,
    conditions: {
        clientExpired: true,
        hasEnteredPin: false,
        isReenroll: false,
        nullGroup: false,
        queryParam: false,
        isPrimary: true,
        isRasHH: false,
        hasValidConsent: false,
        hasActiveEngagement: false,
        hasDocuments: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
    }
};

export const clientExpiredNoPlanCoClientLedReenroll = {
    type: 'CLIENT_EXPIRED_NO_PLAN_CO_CLIENT_LED_REENROLL',
    route: CLIENT_CONSENT_REENROLL,
    prority: 2,
    conditions: {
        clientExpired: true,
        hasEnteredPin: false,
        isReenroll: false,
        nullGroup: false,
        queryParam: false,
        isPrimary: true,
        isRasHH: false,
        hasValidConsent: false,
        hasDocuments: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,
        coClientExpired: false,
        multipleClients: true
    }
};

export const noClientConsentCoClientLedReenrollCTS = {
    type: 'NO_CLIENT_CONSENT_COCLIENT_LED_REENROLL_CTS',
    route: CLIENT_CONSENT_REENROLL,
    priority: 2,
    description: 'User has an engagment that was previously led by a CC before CTS',
    conditions: {
        isNEWE: false,
        isExpressEng: false,
        isPrimary: true,
        clientExpired: true,
        isRasHH: false,
        hasActiveEngagement: true
    }
};

export const reenrollCoClient = {
    type: 'REENROLL_CO_CLIENT',
    route: CO_CLIENT_CONSENT_REENROLL,
    priority: 2,
    description: 'Co client has expired consent and is reenrolling',
    conditions: {
        coClientExpired: true,
        hasEnteredPin: false,
        isReenroll: true,
        clientExpired: true,
        isPrimary: false,
        hasExpiredPrcnEngagement: false,
        multipleClients: true
    }
};

export const coClientConsentReenrollCoClient = {
    type: 'CO_CLIENT_CONSENT_REENROLL',
    route: CO_CLIENT_CONSENT_REENROLL,
    priority: 2,
    description: 'Co client has expired consent and is reenrolling to 5 part consent',
    conditions: {
        coClientExpired: true,
        hasEnteredPin: false,
        clientExpired: false,
        isReenroll: false,
        isPrimary: false,
        isRasActive: false,
        hasExpiredPrcnEngagement: false,
        multipleClients: true
    }
};

export const cngnClient = {
    type: 'CONSENT_GIVEN_CLIENT',
    route: TRANSITION,
    priority: 2,
    description: 'Client has completed prosperus account selection consent',
    conditions: {
        isPrimary: true,
        isCNGN: true,
        pastEngagements: false,
        isProspClient: true,
        clientExpired: false,
    }
};

export const cngnNonProsp = {
    type: 'CONSENT_GIVEN_NON_PROSP',
    route: CONSENT_GIVEN,
    priority: 2,
    description: 'Client has completed 5 part consent',
    conditions: {
        isPrimary: true,
        isCNGN: true,
        pastEngagements: false,
        isProspClient: false,
        clientExpired: false,
    }
}

export const cngnReenrollClient = {
    type: 'CONSENT_GIVEN_REENROLL_CLIENT',
    route: CONSENT_GIVEN_REENROLL,
    priority: 2,
    conditions: {
        isPrimary: true,
        pastEngagements: true,
        isCNGN: true,
        clientExpired: false,
    }
};

export const isPrcnHasConsent = {
    type: 'PRCN_HAS_CONSENT',
    route: CONSENT_GIVEN,
    priority: 1,
    conditions:
        {
            isPRCN: true,
            hasValidConsent: true,
            hasPrcnNeedsConsent: false,
        }
}

export const cngnCoClient = {
    type: 'CONSENT_GIVEN_CO_CLIENT',
    route: CONSENT_GIVEN,
    priority: 2,
    description: 'Co client has no previous engagements, CNGN status',
    conditions: {
        isPrimary: false,
        isCNGN: true,
        pastEngagements: false,
        coClientExpired: false,
    }
};

export const cngnReenrollCoClient = {
    type: 'CONSENT_GIVEN_REENROLL_CO_CLIENT',
    route: CONSENT_GIVEN_REENROLL,
    priority: 2,
    description: 'Co client has previous engagements, CNGN status',
    conditions: {
        isPrimary: false,
        isCNGN: true,
        pastEngagements: true,
        coClientExpired: false,
    }
};

export const apndClient = {
    type: 'APND_CLIENT',
    route: APPOINTMENT_INFO,
    priority: 2,
    description: 'APND Client, no previous engagements',
    conditions: {
        isAPND: true,
        isPrimary: true,
        clientExpired: false,
        pastEngagements: false
    }
};

export const apndReenrollClient = {
    type: 'APND_REENROLL_CLIENT',
    route: APPOINTMENT_INFO_REENROLL,
    conditions: {
        isAPND: true,
        isPrimary: true,
        clientExpired: false,
        pastEngagements: true
    }
};

export const apndCoClient = {
    type: 'APND_CO_CLIENT',
    route: APPOINTMENT_INFO,
    priority: 2,
    description: 'APND Co Client, no previous engagements',
    conditions: {
        isAPND: true,
        isPrimary: false,
        coClientExpired: false,
        pastEngagements: false
    }
};

export const apndReenrollCoClient = {
    type: 'APND_REENROLL_CO_CLIENT',
    route: APPOINTMENT_INFO_REENROLL,
    priority: 2,
    description: 'APND Co Client, has previous engagements',
    conditions: {
        isAPND: true,
        isPrimary: false,
        coClientExpired: false,
        pastEngagements: true
    }
};

export const apscClient = {
    type: 'APSC_CLIENT',
    route: APPOINTMENT_INFO,
    priority: 2,
    description: 'APSC Client, no previous engagements',
    conditions: {
        isAPSC: true,
        isPrimary: true,
        clientExpired: false,
        pastEngagements: false
    }
};

export const apscCoClient = {
    type: 'APSC_CO_CLIENT',
    route: APPOINTMENT_INFO,
    priority: 2,
    description: 'APSC Co Client, no previous engagements',
    conditions: {
        isAPSC: true,
        isPrimary: false,
        coClientExpired: false,
        pastEngagements: false
    }
};

export const apscReenrollClient = {
    type: 'APSC_REENROLL_CLIENT',
    route: APPOINTMENT_INFO_REENROLL,
    priority: 2,
    description: 'APSC Client, has previous engagements',
    conditions: {
        isAPSC: true,
        isPrimary: true,
        clientExpired: false,
        pastEngagements: true
    }
};

export const apscReenrollCoClient = {
    type: 'APSC_REENROLL_CO_CLIENT',
    route: APPOINTMENT_INFO_REENROLL,
    priority: 2,
    description: 'APSC Co Client, has previous engagements',
    conditions: {
        isAPSC: true,
        isPrimary: false,
        coClientExpired: false,
        pastEngagements: true
    }
};

export const pldlClient = {
    type: 'PLDL_CLIENT',
    route: PLAN_DELIVERED,
    priority: 2,
    description: 'PLDL Client',
    conditions: {
        isPLDL: true,
        isPrimary: true,
        clientExpired: false
    }
};

export const pldlCoClient = {
    type: 'PLDL_CO_CLIENT',
    route: PLAN_DELIVERED,
    priority: 2,
    description: 'PLDL Co-client',
    conditions: {
        isPLDL: true,
        isPrimary: false,
        coClientExpired: false
    }
};

export const btrClientConsent = {
    type: 'BTR_CLIENT_CONSENT',
    route: CLIENT_CONSENT_REENROLL,
    priority: 1,
    description: 'BTR/Archived client reenrolling',
    conditions: {
        nullGroup: true,
        isReenroll: true,
        isLimbo: true
    }
};

export const btrClient = {
    type: 'BTR_CLIENT',
    route: '/new-plan',
    conditions: {
        isLimbo: true,
        isReenroll: false,
        hasEnteredPin: false
    }
};

export const btrCoClientConsent = {
    type: 'BTR_CO_CLIENT_CONSENT',
    route: CO_CLIENT_CONSENT,
    priority: 1,
    description: 'BTR/Archived Co-client joining RAS HH, has entered Pin',
    conditions: {
        isLimbo: true,
        isReenroll: false,
        hasEnteredPin: true
    }
}

export const coClientExpiredNoPlan = {
    type: 'CO_CLIENT_EXPIRED_NO_PLAN',
    route: CO_CLIENT_EXPIRED,
    description: 'Co-Client is expired, no plan, no consent, no active engagement',
    priority: 2,
    conditions: {
        coClientExpired: true,
        hasEnteredPin: false,
        isReenroll: false,
        nullGroup: false,
        queryParam: false,
        isPrimary: false,
        isRasHH: false,
        hasValidConsent: false,
        hasActiveEngagement: false,
        hasDocuments: false,
        hasExpiredPrcnEngagement: false,
        hasPrcnNeedsConsent: false,

    }
}


export const expiredNoPlanCoClient = {
    type: 'EXPIRED_NO_PLAN_CO_CLIENT',
    route: CO_CLIENT_EXPIRED,
    priority: 2,
    description: 'Co client expired, has no documents',
    conditions: {
        conditions: {
            coClientExpired: true,
            clientExpired: true,
            isPrimary: false,
            isRasActive: false,
            isRasHH: false,
            hasDocuments: false,
        }
    }
};

export const nonRasNonHHCoClient = {
    type: 'NON_RAS_NON_HOUSEHOULD_CO_CLIENT',
    route: CO_CLIENT_REENROLL,
    priority: 2,
    description: 'Non-RAS active, non-RAS HH co-client',
    conditions: {
        coClientExpired: true,
        isReenroll: false,
        isPrimary: false,
        queryParam: false,
        isRasActive: false,
        clientExpired: true
    }
};

export const nonRasNonHHCoClientActiveEngagement = {
    type: 'NON_RAS_NON_HOUSEHOULD_CO_CLIENT',
    route: CO_CLIENT_CONSENT_REENROLL,
    priority: 2,
    description: 'Non-RAS active, non-RAS HH co-client, client has active engagement',
    conditions: {
        coClientExpired: true,
        isReenroll: false,
        isPrimary: false,
        queryParam: false,
        isRasActive: false,
        clientExpired: false
    }
};

export const nonRasActiveHHClientWithQuery = {
    type: 'NON_RAS_ACTIVE_HOUSEHOLD_CLIENT_WITH_QUERY',
    route: ACCOUNT_SELECTION,
    priority: 2,
    description: 'Non-RAS active, RAS HH client with query param',
    conditions: {
        isLimbo: false,
        isReenroll: false,
        isPrimary: true,
        queryParam: true,
        isRasActive: false,
        isRasHH: true
    }
};

export const nonRasActiveHHCoClient = {
    type: 'NON_RAS_ACTIVE_HOUSEHOLD_CO_CLIENT',
    route: '/'
};

export const rasActiveRasHHClient = {
    type: 'RAS_ACTIVE_RAS_HOUSEHOLD_CLIENT',
    route: ACCOUNT_SELECTION,
    priority: 2,
    conditions: {
        isLimbo: false,
        isReenroll: false,
        isPrimary: true,
        queryParam: true,
        isRasActive: true,
        isRasHH: true
    }
};

export const rasActiveRasHHCoClient = {
    type: 'RAS_ACTIVE_RAS_HOUSEHOLD_CO_CLIENT',
    route: ACCOUNT_SELECTION
};

export const rasActiveRasHHClientExpiredCoClient = {
    type: 'CLIENT_EXPIRED_RAS_ACTIVE_RAS_HH_CO_CLIENT',
    route: ACCOUNT_SELECTION,
    priority: 2,
    description: 'RAS active, RAS HH, client consent expired, co client',
    conditions: {
        isPrimary: false,
        coClientExpired: true,
        clientExpired: true,
        queryParam: true,
        isRasHH: true,
        isRasActive: true,
    }
};

export const rasActiveNotRasHHClientExpiredCoClient = {
    type: 'CLIENT_EXPIRED_RAS_ACTIVE_NOT_RAS_HH_CO_CLIENT',
    route: ACCOUNT_SELECTION,
    priority: 2,
    description: 'RAS active, Not RAS HH, client consent expired, co client',
    conditions: {
        isPrimary: false,
        coClientExpired: true,
        clientExpired: true,
        isRasHH: false,
        isRasActive: true,
    }
};

export const rasActiveClientConsentedCoClientExpNoQueryParam = {
    type: 'CLIENT_CONSENTED_RAS_ACTIVE_RAS_HH_CO_CLIENT_EXPIRED_NO_QUERY_PARAM',
    route: ACCOUNT_SELECTION,
    priority: 2,
    description: 'RAS active client in HH, client consent active, co client',
    conditions: {
        isPrimary: false,
        coClientExpired: true,
        clientExpired: false,
        isRasActive: true,
    }
};

export const rasActiveRasHHClientConsentedCoClientExp = {
    type: 'CLIENT_CONSENTED_RAS_ACTIVE_RAS_HH_CO_CLIENT_EXPIRED',
    route: ACCOUNT_SELECTION,
    priority: 2,
    description: 'RAS active client in HH, RAS HH, client consent expired, co client',
    conditions: {
        isPrimary: false,
        coClientExpired: true,
        clientExpired: false,
        queryParam: true,
        isRasHH: true,
        isRasActive: true,
    }

};

export const rasActiveRasHHClientConsentedCoClientJoin = {
    type: 'CLIENT_CONSENTED_RAS_ACTIVE_RAS_HH_CO_CLIENT_JOIN',
    route: ACCOUNT_SELECTION,
    priority: 1,
    conditions: {
        isLimbo: false,
        isReenroll: false,
        hasEnteredPin: true,
        notRasOnboarding: true,
        isPrimary: false,
        nullGroup: true
    }
};

export const btrCoClientJoinRasHH = {
    type: 'BTR_CO_CLIENT_JOIN_RAS_HH',
    route: ACCOUNT_SELECTION,
    priority: 1,
    description: 'BTR Co client joining RAS HH',
    conditions: {
        isLimbo: true,
        notRasOnboarding: true,
        isReenroll: false,
        hasEnteredPin: true
    }

};

export const nonRasActiveRasHHClientConsentedCoClientExpClickedModal = {
    type: 'CLIENT_CONSENTED_NON_RAS_ACTIVE_RAS_HH_CO_CLIENT_EXPIRED',
    route: ACCOUNT_SELECTION,
    description: 'Non-RAS active client in HH, RAS HH, client consent expired, co client, clicked education continue modal',
    conditions: {
        isPrimary: false,
        coClientExpired: true,
        clientExpired: false,
        isRasHH: true,
        isRasActive: false,
        educationContinue: true,
    }
}

export const rasActiveHHClientNoQuery = {
    type: 'RAS_ACTIVE_HH_CLIENT_NO_QUERY',
    route: MONITOR,
    priority: 2,
    description: 'RAS HH client, client consent expired, no query param',
    conditions: {
        isRasHH: true,
        clientExpired: true,
        hasActiveEngagement: false,
        educationContinue: false,
        isPrimary: true,
        queryParam: false
    }
};

export const rasHHNotRasActiveClientClickedEdModal = {
    type: 'NOT_RAS_ACTIVE_HH_CLIENT_CLICKED_ED_MODAL',
    route: ACCOUNT_SELECTION,
    priority: 2,
    description: 'RAS HH not ras active client, client consent expired, clicked education continue modal',
    conditions: {
        isRasHH: true,
        clientExpired: true,
        isRasActive: false,
        educationContinue: true,
        isPrimary: true,
        queryParam: false
    }
};

export const rasHHRasActiveClientClickedEdModal = {
    type: 'RAS_ACTIVE_HH_CLIENT_CLICKED_ED_MODAL',
    route: ACCOUNT_SELECTION,
    priority: 2,
    description: 'RAS HH ras active client, client consent expired, clicked education continue modal',
    conditions: {
        isRasHH: true,
        clientExpired: true,
        isRasActive: true,
        educationContinue: true,
        isPrimary: true,
        queryParam: false
    }
}

export const rasHHNotRasActiveCoClientClickedEdModal = {
    type: 'RAS_HH_CO_CLIENT_CLICKED_ED_MODAL',
    route: ACCOUNT_SELECTION,
    description: 'RAS HH not ras active co client, client consent expired, clicked education continue modal',
    conditions: {
        isRasHH: true,
        clientExpired: true,
        coClientExpired: true,
        isRasActive: false,
        educationContinue: true,
        isPrimary: false,
        queryParam: false
    }
};

export const rasHHRasActiveExpiredClientCoClientClickedModal = {
    type: 'RAS_ACTIVE_RAS_HH_EXPIRED_CLIENT_CO_CLIENT_CLICKED_ED_MODAL',
    route: ACCOUNT_SELECTION,
    conditions: {
        isPrimary: false,
        coClientExpired: true,
        clientExpired: true,
        isRasHH: true,
        isRasActive: true,
        educationContinue: true,
    }
};

export const rasHHRasActiveExpiredClientCoClientLed = {
    type: 'RAS_ACTIVE_RAS_HH_EXPIRED_CLIENT_CO_CLIENT_LED',
    route: ACCOUNT_SELECTION,
    priority: 2,
    description: 'RAS HH ras active client, client consent expired, co-client led',
    conditions: {
        isRasHH: true,
        clientExpired: true,
        coClientExpired: false,
        multipleClients: true,
        hasActiveEngagement: true,
        isPrimary: true,
        queryParam: false
    }
}

export const rasActiveHHCoClientNoQuery = {
    type: 'RAS_ACTIVE_HH_CO_CLIENT_NO_QUERY',
    route: MONITOR,
    priority: 3,
    conditions: {
        isPrimary: false,
        coClientExpired: true,
        educationContinue: false,
        clientExpired: true,
        isRasHH: true,
        isRasActive: true,
        queryParam: false
    }
};

export const rasHHNotRasActiveCoClient = {
    type: 'RAS_HH_NOT_RAS_ACTIVE_ACTIVE_CLIENT_CONSENT_CO_CLIENT',
    route: ACCOUNT_SELECTION,
    priority: 2,
    description: 'RAS HH not ras active co client, client consented',
    conditions: {
        isRasHH: true,
        clientExpired: false,
        coClientExpired: true,
        isRasActive: false,
        isPrimary: false,
        educationContinue: false,
    }

}

export const rasHHNotRasActiveClientExpiredCoClient = {
    type: 'RAS_HH_NOT_RAS_ACTIVE_CLIENT_EXPIRED_CO_CLENT',
    route: MONITOR,
    priority: 2,
    description: 'RAS HH not ras active co client, client consent expired',
    conditions: {
        isRasHH: true,
        clientExpired: true,
        coClientExpired: true,
        isRasActive: false,
        isPrimary: false,
        queryParam: false
    }
};

export default {
    onboardingClient,
    expressPathClient,
    isPrcnHasConsent,
    expressEngagementClient,
    advisorLedOnboardingClient,
    expiredPrcnEngagementClient,
    expiredPrcnEngagementCoClient,
    expiredPrcnEngagementRasClient,
    expiredPrcnEngagementRasCoClient,
    preProspCompletionCoClient,
    advisorLedRasHHClient,
    clientReenrollCoClientLedEngagement,
    onboardingCoClient,
    advisorLedOnboardingCoClient,
    advisorLedRasHHCoClient,
    rasHHcoClientLedRoundTripCTSClient,
    prosperusClient,
    kyccClient,
    glscClient,
    rtqcClient,
    intcClient,
    extcClient,
    mancClient,
    fpacClient,
    rasActiveNotRasHHClientExpiredCoClient,
    reenrollClient,
    clientExpiredReenroll,
    clientExpiredNoPlan,
    clientExpiredNoPlanCoClientLedReenroll,
    noClientConsentCoClientLedReenrollCTS,
    reenrollCoClient,
    nonRasNonHHCoClientActiveEngagement,
    cngnClient,
    cngnNonProsp,
    cngnReenrollClient,
    cngnCoClient,
    cngnReenrollCoClient,
    btrCoClientJoinRasHH,
    apndClient,
    apndReenrollClient,
    apndCoClient,
    apndReenrollCoClient,
    apscClient,
    apscCoClient,
    apscReenrollClient,
    apscReenrollCoClient,
    pldlClient,
    pldlCoClient,
    btrClientConsent,
    btrClient,
    btrCoClientConsent,
    coClientExpiredNoPlan,
    expiredNoPlanCoClient,
    nonRasNonHHCoClient,
    nonRasActiveHHClientWithQuery,
    nonRasActiveHHCoClient,
    rasActiveRasHHClient,
    rasActiveRasHHCoClient,
    rasActiveRasHHClientExpiredCoClient,
    rasActiveHHCoClientNoQuery,
    rasActiveClientConsentedCoClientExpNoQueryParam,
    rasActiveRasHHClientConsentedCoClientJoin,
    nonRasActiveRasHHClientConsentedCoClientExpClickedModal,
    rasHHRasActiveExpiredClientCoClientLed,
    rasHHRasActiveExpiredClientCoClientClickedModal,
    rasHHNotRasActiveClientExpiredCoClient,
    rasActiveHHClientNoQuery,
    rasHHNotRasActiveCoClient,
    rasHHNotRasActiveCoClientClickedEdModal,
    rasHHRasActiveClientClickedEdModal,
    rasHHNotRasActiveClientClickedEdModal
};
